var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashDeprecated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2.16672H10.125L9.8802 1.67974C9.77443 1.46738 9.55754 1.33321 9.3203 1.33338H6.34374C6.10695 1.33247 5.89047 1.46701 5.78645 1.67974L5.54166 2.16672H2.41667C2.18655 2.16672 2 2.35326 2 2.58338V3.41671C2 3.64683 2.18655 3.83338 2.41667 3.83338H13.25C13.4801 3.83338 13.6667 3.64683 13.6667 3.41671V2.58338C13.6667 2.35326 13.4801 2.16672 13.25 2.16672ZM3.38541 13.4948C3.42666 14.1535 3.97285 14.6667 4.63281 14.6667H11.0338C11.6938 14.6667 12.24 14.1535 12.2812 13.4948L12.8333 4.66671H2.83333L3.38541 13.4948Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashDeprecated);
export default __webpack_public_path__ + "static/media/trash_deprecated.7d123176c52215cdc61bf3bdb359a42b.svg";
export { ForwardRef as ReactComponent };